import { render, staticRenderFns } from "./element-icon.vue?vue&type=template&id=45d24295"
import script from "./element-icon.vue?vue&type=script&lang=js"
export * from "./element-icon.vue?vue&type=script&lang=js"
import style0 from "./element-icon.vue?vue&type=style&index=0&id=45d24295&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports